import React, { useContext } from 'react'
import { Experiment, Variation } from '@deal/experiment-js'
import {
  ConsumerSellableReactionFragment,
  ConsumerSellableReactionRating
} from '#src/generated/graphql'
import { IdentityContext } from '#src/containers/Identity'
import SellableReactions from '#src/components/SellableReactions'
import styles from './styles.css'

interface Props {
  sellableReactions?: ConsumerSellableReactionFragment[]
  onSellableRatingSelected: (rating: ConsumerSellableReactionRating) => void
  openFeedbackModal?: () => void
}

const SellableReaction: React.SFC<Props> = ({
  sellableReactions,
  onSellableRatingSelected,
  openFeedbackModal
}) => {
  const { myself } = useContext(IdentityContext)

  if (!myself) {
    return null
  }

  return (
    <Experiment id="product-page-reaction" default="off">
      <Variation id="on">
        <div className={styles.content}>
          <div className={styles.text}>Let your expert know what you think about this</div>
          <div className={styles.buttonsContainer}>
            <SellableReactions
              onSellableRatingSelected={onSellableRatingSelected}
              hideSkip
              selectedRating={
                (sellableReactions &&
                  sellableReactions[0] &&
                  sellableReactions[0].ratingWithDisplayName) ||
                null
              }
              onProductDisliked={openFeedbackModal}
            />
          </div>
        </div>
      </Variation>
      <Variation id="off" />
    </Experiment>
  )
}

export default SellableReaction
